<template>
  <div class="container">
    <div class="mask clipboard">
      <div class="success-pop">
        <h2>欢迎加入邮乐优鲜！</h2>
        <img src="../../../../assets/img/invi-2.png" />
        <a @click="doCopy" href="javascript:void(0);" class="btn-apply clipboard">去下载APP！</a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
    name: "downapp",
    data() {
        return {

        };
    },
    mounted() {

    },
    methods: {
        toDownload() {
            setTimeout(() => {
                window.location =
                    "https://a.app.qq.com/o/simple.jsp?pkgname=com.ule.storecommunity";
            }, 1000);
        },        
        doCopy() {
            this.copyText('https://a.app.qq.com/o/simple.jsp?pkgname=com.ule.storecommunity', this.toDownload, this.toDownload);
        },
    },
};
</script>
<style>
</style>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    .mask {
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 2;
        background: rgba(0, 0, 0, 0.3);
        .success-pop {
            width: 80%;
            padding: 20px 15px;
            background: #fff;
            border-radius: 10px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            box-sizing: border-box;
            h2 {
                font-size: 20px;
                color: #333;
                text-align: center;
                margin-bottom: 10px;
            }
            .btn-apply {
                background-image: linear-gradient(to right, #ff7d43, #fe3247);
                font-size: 16px;
                border-radius: 30px;
                color: #fff;
                line-height: 40px;
                width: 80%;
                text-align: center;
                display: block;
                margin: 0 auto;
                margin-top: 6px;
            }
        }
    }
}
</style>

